import React from 'react';
import { dateOnlySlashesFormat, formatUtcDate } from 'App/services/DateService';
import { formatPhone } from 'App/utils';
import { financialAssistanceReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const FADefaultReviewContent = ({ financialAssistanceReferralDetails }) => {
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details</strong>
                <div>Status: {financialAssistanceReferralDetails.status}</div>
                <div>
                    Did the patient file an application {financialAssistanceReferralDetails.fileApplication?.id || '--'}
                </div>
                <div>
                    Application Submission Date:{' '}
                    {formatUtcDate({
                        date: financialAssistanceReferralDetails.applicationSubmission?.toISOString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>
                <div>Selected program: {financialAssistanceReferralDetails.programName || '--'}</div>

                <div>
                    Follow Up Phone Number: {formatPhone(financialAssistanceReferralDetails.followUpPhone) || '--'}
                </div>

                <div>
                    Effective Start and End Dates:{' '}
                    {formatUtcDate({
                        date: financialAssistanceReferralDetails.effectiveStartDate?.toISOString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}{' '}
                    -{' '}
                    {formatUtcDate({
                        date: financialAssistanceReferralDetails.effectiveEndDate?.toISOString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>

                <div>Amount Funded: {financialAssistanceReferralDetails.amountFunded || '--'}</div>
                <div>Other Assistance Approved: {financialAssistanceReferralDetails.otherAssistance || '--'}</div>
                <div>Financial Assistance Source: {financialAssistanceReferralDetails.fundingSource?.id || '--'}</div>

                <div>
                    Is it covering part/all of the medication cost?{' '}
                    {financialAssistanceReferralDetails.isCoveringMedicationCost?.name || '--'}
                </div>

                <div>
                    Is re-enrollment to the program required:{' '}
                    {financialAssistanceReferralDetails.isReEnrollmentRequired?.name || '--'}
                </div>

                <div>
                    Schedule the follow-up activity on completion?
                    {financialAssistanceReferralDetails.followUpScheduleOption || '--'}{' '}
                    {financialAssistanceReferralDetails.followUpDueDate || '--'}
                </div>
                <div>Notes: {financialAssistanceReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

FADefaultReviewContent.propTypes = {
    financialAssistanceReferralDetails: financialAssistanceReferralDetailsPropType.isRequired,
};

export default FADefaultReviewContent;
